import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const Forbrukning = lazy(() => import("@/pages/mina-sidor/Forbrukning"));

export const Route = createFileRoute("/mina-sidor/forbrukning")({
  component: () => <Forbrukning />,
});
